<template>
  <div class="flex overflow-hidde">
    <div class="h-full w-full relative overflow-y-auto">
      <main>
        <div
          class="w-full grid grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 gap-4 grid-flow-row-dense"
        >
          <container-export-status
            v-if="
              checkIfUserIsAuthorizedInRole(
                'production',
                'basic_container_export'
              ) ||
              checkIfUserIsAuthorizedInRole(
                'production',
                'query_container_export'
              )
            "
            :agro_exporter_id="this.userEntityId('agro_exporter')"
          />
          <container-final-quality-status
            v-if="
              checkIfUserIsAuthorizedInRole(
                'production',
                'basic_container_quality'
              ) ||
              checkIfUserIsAuthorizedInRole(
                'production',
                'query_container_quality'
              )
            "
            :agro_exporter_id="this.userEntityId('agro_exporter')"
          />
          <container-outcomes
            v-if="
              checkIfUserIsAuthorizedInRole('finances', 'container_outcomes') ||
              checkIfUserIsAuthorizedInRole(
                'finances',
                'query_container_outcomes'
              )
            "
            :agro_exporter_id="this.userEntityId('agro_exporter')"
          />
          <container-incomes
            v-if="
              checkIfUserIsAuthorizedInRole('finances', 'container_incomes') ||
              checkIfUserIsAuthorizedInRole(
                'finances',
                'query_container_incomes'
              )
            "
            :agro_exporter_id="this.userEntityId('agro_exporter')"
          />
          <certifications-expired
            class="row-span-2"
            v-if="
              checkIfUserIsAuthorizedInRole('certifications', 'providers') ||
              checkIfUserIsAuthorizedInRole('certifications', 'query_providers')
            "
            :agro_exporter_id="this.userEntityId('agro_exporter')"
          />
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import CertificationsExpired from "@/components/views/dashboard/agro_exporter/CertificationsExpired.vue";
import ContainerIncomes from "@/components/views/dashboard/agro_exporter/ContainerIncomes.vue";
import ContainerOutcomes from "@/components/views/dashboard/agro_exporter/ContainerOutcomes.vue";
import ContainerExportStatus from "@/components/views/dashboard/agro_exporter/ContainerExportStatus.vue";
import ContainerFinalQualityStatus from "@/components/views/dashboard/agro_exporter/ContainerFinalQualityStatus.vue";
export default {
  name: "DashboardAgroExporter",
  components: {
    CertificationsExpired,
    ContainerIncomes,
    ContainerOutcomes,
    ContainerExportStatus,
    ContainerFinalQualityStatus
  },
  methods: {
    checkIfUserIsAuthorizedInRole(role, permission) {
      return this.checkIfUserIsAuthorized(role, permission, "agro_exporter");
    }
  }
};
</script>
